<template>
    <div class="bk-modal-overlay" @click.self="dismiss">
        <div class="bk-modal" :style="frameStyle">
            <div class="bk-modal-header" v-if="entry.options.title">
                <span>{{ entry.options.title }}</span>
                <button @click="dismiss" class="bk-modal-close">&times;</button>
            </div>
            <div class="bk-modal-body">
                <component :is="entry.component" v-bind="entry.props" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { provide, computed } from 'vue'
import ModalService, { MODAL_CLOSE, type ModalEntry } from '@/services/modal'

const props = defineProps<{ entry: ModalEntry }>()

const dismiss = () => ModalService.closeById(props.entry.id, undefined)
const closeFn = (result?: any) => ModalService.closeById(props.entry.id, result)

provide(MODAL_CLOSE, closeFn)

const frameStyle = computed(() => {
    const o = props.entry.options
    return {
        width: o.width || 'auto',
        maxWidth: o.maxWidth || '95vw',
        height: o.height || 'auto'
    }
})
</script>

<style>
.bk-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}
.bk-modal {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.25);
    display: flex;
    flex-direction: column;
    max-height: 95vh;
    overflow: hidden;
}
.bk-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #37474f;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    border-radius: 8px 8px 0 0;
    flex-shrink: 0;
}
.bk-modal-close {
    background: none;
    border: none;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    line-height: 1;
    padding: 0 4px;
    opacity: 0.8;
}
.bk-modal-close:hover { opacity: 1; }
.bk-modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 0;
}
</style>
